import { useEffect, useState } from "react";
import Button1 from "../../form/Button1";
import PinForm from "../../Settings/PinForm";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import ModalContainer from "../../common/ModalContainer";
import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import CommonTextAreaInput from "../../common/inputs/CommonTextAreaInput";
import debitAgencyWallet from "../../../controllers/settings/wallet/debitAgencyWallet";

const CustomerDetailWalletDebitModal = ({
  open,
  setOpen,
  data: defData,
  currency,
  reload,
  setLoading,
  loading,
}) => {
  const {
    userData: { user },
  } = useSelector((state) => state.user);
  const [data, setData] = useState({
    amount: "",
    reason: "",
  });
  const [openPin, setOpenPin] = useState(false);

  const currencyCode = currency?.code || currency?.currency || "NGN";

  useEffect(() => {
    if (open) {
      setData({ amount: "", reason: "" });
    }
  }, [open]);

  const handleDebit = async (pin) => {
    if (user?.advancedSecurityEnabled && !pin) return setOpenPin(true);

    setLoading(true);
    const res = await debitAgencyWallet({
      accountId: defData?._id,
      amount: Number(data?.amount),
      reason: data?.reason || "",
      currency: currencyCode,
      pin,
    });
    setLoading(false);
    if (res.return) {
      enqueueSnackbar("Wallet debited successully", { variant: "success" });
      setOpen(false);
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  };

  return (
    <>
      <ModalContainer
        open={open}
        setOpen={setOpen}
        title="Debit wallet"
        subTitle={
          currencyCode
            ? `Debiting ${currency?.name || currencyCode} (${currencyCode})`
            : undefined
        }
        childClassname="max-w-[420px]"
        padding="p-4 sm:p-5"
      >
        <div className="flex flex-col gap-4">
          <div className="rounded-lg border border-[#E8EEF5] bg-[#F8FAFC] px-3 py-2.5 flex items-center justify-between gap-3">
            <span className="text-sm text-[#6D7C94]">Wallet currency</span>
            <span className="text-sm font-semibold text-primary1">
              {currencyCode}
            </span>
          </div>

          <div className="relative">
            <CommonFreeTextInput
              label="Amount"
              type="number"
              placeholder="0.00"
              value={data.amount || ""}
              onChange={(val) => setData({ ...data, amount: val })}
            />
            <span className="pointer-events-none absolute right-4 bottom-3 text-sm font-medium text-[#6D7C94]">
              {currencyCode}
            </span>
          </div>

          <CommonTextAreaInput
            label="Reason"
            placeholder="Why are you debiting this wallet?"
            value={data.reason || ""}
            onChange={(val) => setData({ ...data, reason: val })}
          />

          <div className="flex gap-2 pt-1">
            <Button1 className="btn-theme-light" onClick={() => setOpen(false)}>
              Cancel
            </Button1>
            <Button1
              loading={loading}
              onClick={() => handleDebit()}
              className="whitespace-nowrap"
              disabled={!data.amount}
            >
              Debit wallet
            </Button1>
          </div>
        </div>
      </ModalContainer>
      <ModalContainer
        title="PIN"
        open={openPin}
        setOpen={() => handleDebit()}
        childClassname="max-w-[420px]"
        padding="p-4 sm:p-5"
      >
        <PinForm
          callback={(pin) => {
            setOpenPin(false);
            handleDebit(pin);
          }}
          close={() => setOpenPin(false)}
        />
      </ModalContainer>
    </>
  );
};

export default CustomerDetailWalletDebitModal;
